import { gql } from '@apollo/client'

export const VIEW_LIST_FRAGMENT = gql`
  fragment ViewDataList on View {
    id
    name
    default
    active
    themes {
      id
      name
      categories {
        id
        name
      }
    }
  }
`

export const VIEW_LIST_SIMPLE_FRAGMENT = gql`
  fragment ViewSimpleList on View {
    id
    name
    default
    active
  }
`

export const PRODUCT_VIEW_FILTERS_FRAGMENT = gql`
  fragment ProductViewFilters on View {
    filters {
      ages {
        or
      }
      aspects {
        or
        not
        and
      }
      authors {
        or
        not
      }
      categories {
        or
        or_additional
        not
        and
      }
      audiences {
        or
        not
      }
      devices {
        or
      }
      feeds {
        or
        not
      }
      followers {
        min
        max
      }
      genders {
        or
      }
      geoLocations {
        country {
          or
          not
        }
        county {
          or
          not
        }
        region {
          or
          not
        }
        locality {
          or
          not
        }
      }
      storesMetadata {
        key
        values
      }
      hashtags {
        or
        not
        and
      }
      interests {
        or
      }
      isDark
      locations {
        or
        not
      }
      maritalStatuses {
        or
      }
      mentions {
        or
        not
        and
      }
      occupations {
        or
      }
      ratings {
        or
      }
      sentiments {
        or
      }
      stores {
        or
        not
      }
      texts {
        ands
        ors
        nots
      }
      themes {
        or
      }
      types {
        or
      }
    }
  }
`
